import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../environments/environment";
import { EnvironmentModel } from "@keus-template/environment";

/**
 * An interceptor to update request headers with token information
 * and replace '%' with '&' in URLs in production.
 */
@Injectable()
export class UpdateUrlInterceptor implements HttpInterceptor {
  /** The environment settings */
  private readonly _environment: EnvironmentModel = environment;

  /** Indicates whether the application is running in a production environment. */
  private readonly _isEnvironmentProduction: boolean =
    this._environment.production;

  /**
   * Intercepts HTTP requests to add token data to the headers
   * and optionally replace '%' with '&' in the URL for production.
   * @param request The original HTTP request.
   * @param next The HTTP handler for the request.
   * @returns An observable of the HTTP event.
   */
  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.headers.get("X-Skip-Interceptor") === "true") {
      const updatedRequest = request.clone({
        headers: request.headers.delete("X-Skip-Interceptor"),
      });

      return next.handle(updatedRequest);
    }

    let updatedUrl = request.url;
    let updatedRequest = request;

    if (this._isEnvironmentProduction)
      updatedUrl = updatedUrl.replace(/%/g, "&");

    try {
      updatedRequest = request.clone({
        url: updatedUrl,
      });
    } catch (error) {
      console.error("Error update url interceptor:", error);
    }

    return next.handle(updatedRequest);
  }
}
